// Single source of truth for the backend API base URL.
//
// In production builds this is the relative path /api: every domain that the
// Amplify app serves (urban-tech.se, urban-playbook.com, healthy-urbanism.com)
// reverse-proxies /api/* to https://api.urban-tech.se via an Amplify rewrite
// rule. Same-origin requests keep the httpOnly auth cookie first-party on all
// domains and avoid CORS entirely.
//
// REACT_APP_API_URL (from .env.development / .env.production) overrides this,
// e.g. for local development against a deployed API.
const API_BASE_URL: string = process.env.REACT_APP_API_URL || '/api';

export default API_BASE_URL;
